import { NoticeContact } from './NoticePreviewFrame';
import { fmtDate, fmtTime } from '../Helpers/format';

export const ChecklistPreview = ({ data, residentName = '[Resident name]', unit, propertyTitle, date, moveoutDate, moveoutTime, note, contact = data.contact }) => (
        <section className="pm-email-preview" aria-label="Email preview">
          
          <h4>{data.title}</h4><p>Hi {residentName},</p><p>{data.companyName || 'Your property management team'} is here to help make your move a little easier.</p>
          <p>{data.introduction}</p>
          <p className="pm-inspection-reminder"><strong>Pre-moveout inspection:</strong> {date ? fmtDate(date) : 'Choose an inspection date'}</p>
          <p>{data.preparation}</p>
          <div className="pm-checklist-final">
            <h5>Final Move-Out Date &amp; Time</h5>
            <dl><div><dt>Suite</dt><dd>{unit?.unit_number}</dd></div><div><dt>Date</dt><dd>{moveoutDate ? fmtDate(moveoutDate) : 'Choose a date'}</dd></div><div><dt>Time</dt><dd>{fmtTime(moveoutTime) || 'Choose a time'}<small>Building local time</small></dd></div></dl>
          </div>
          <h5 className="pm-checklist-section">A few things to take care of before you leave</h5>
          <ol className="pm-responsibilities">{data.checklist.map(item => <li key={item.title}><strong>{item.title}</strong><p>{item.text}</p>
            {item.links?.length > 0 && <p className="pm-checklist-links">{item.links.map(link => <a key={link.href} href={link.href}>{link.label}</a>)}</p>}
          </li>)}</ol>
          <h5 className="pm-checklist-section">Your suite cleaning checklist</h5>
          <ul className="pm-cleaning-checklist">{data.cleaningChecklist?.map(item => <li key={item}>{item}</li>)}</ul>
          <h5 className="pm-checklist-section">Charges to keep in mind</h5>
          {data.chargeGroups?.map(group => <table className="pm-checklist-charges" key={group.title}>
            <caption>{group.title}</caption><thead><tr><th scope="col">Item / service</th><th scope="col">Charge</th></tr></thead>
            <tbody>{group.items.map(item => <tr key={item.label}><th scope="row">{item.label}</th><td>{item.amount}{item.detail && <small>{item.detail}</small>}</td></tr>)}</tbody>
          </table>)}
          {note && <><h6>A note from your property team</h6><p className="pm-note">{note}</p></>}
          <p>{data.closing}</p>
          <NoticeContact contact={contact} companyName={data.companyName} />
        </section>
);
